document.addEventListener("DOMContentLoaded", function () {
  const sliderThumbnailContainers =
    document.getElementsByClassName("Slider-thumbnails");
  for (const container of sliderThumbnailContainers) {
    const initThumbnails = container.getElementsByClassName("Slider-thumbnail");

    for (const t of initThumbnails) {
      t.style.display = "none";
    }
    if (initThumbnails.length) initThumbnails[0].style.display = "block";

    if (initThumbnails.length - 1 > 0)
      initThumbnails[1].style.display = "block";
    if (initThumbnails.length - 2 > 0)
      initThumbnails[2].style.display = "block";
  }

  function scrollElementIntoView(element, index) {
    if (index === 0 || index === 1 || index === 2) {
      return;
    }

    const parent = element.parentElement;

    // Calculate the horizontal distance between the element and the center of the parent
    // const elementOffset = element.offsetLeft + (element.offsetWidth / 2) - (parent.offsetWidth / 2);
    const elementOffset =
      element.offsetLeft + element.offsetWidth / 2 - parent.offsetWidth / 2;

    // Set the parent's scrollLeft property to scroll the element into view
    parent.scrollLeft = elementOffset;
  }

  function getActiveThumbnailIndex(refParent) {
    let thumbnails = refParent.getElementsByClassName("Slider-thumbnail");
    for (let i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].classList.contains("active")) {
        return i;
      }
    }
    return 0;
  }

  function handleThumbnailDisplay(thumbnails, index) {
    thumbnails[index].style.display = "block";

    if (index === 0) {
      if (index + 1 < thumbnails.length) {
        thumbnails[index + 1].style.display = "block";
      }
      if (index + 2 < thumbnails.length) {
        thumbnails[index + 2].style.display = "block";
      }
      return;
    }
    if (index === 1) {
      thumbnails[0].style.display = "block";
      if (index + 1 < thumbnails.length) {
        thumbnails[index + 1].style.display = "block";
      }
      return;
    }
    if (index === 2) {
      thumbnails[0].style.display = "block";
      thumbnails[1].style.display = "block";
      return;
    }

    if (index + 2 === thumbnails.length - 1) {
      if (index + 1 < thumbnails.length) {
        thumbnails[index + 1].style.display = "block";
      }
      if (index + 2 < thumbnails.length) {
        thumbnails[index + 2].style.display = "block";
      }
      return;
    }
    if (index + 1 === thumbnails.length - 1) {
      if (index - 1 >= 0) {
        thumbnails[index - 1].style.display = "block";
      }
      if (index + 1 < thumbnails.length) {
        thumbnails[index + 1].style.display = "block";
      }
      return;
    }
    if (index === thumbnails.length - 1) {
      if (index - 1 >= 0) {
        thumbnails[index - 1].style.display = "block";
      }
      if (index - 2 >= 0) {
        thumbnails[index - 2].style.display = "block";
      }
      return;
    }
    if (index + 1 < thumbnails.length) {
      thumbnails[index + 1].style.display = "block";
    }
    if (index + 2 < thumbnails.length) {
      thumbnails[index + 2].style.display = "block";
    }
  }

  function setActiveThumbnail(index, refParent) {
    let thumbnails = refParent.getElementsByClassName("Slider-thumbnail");
    for (const thumbnail of thumbnails) {
      thumbnail.classList.remove("active");
      thumbnail.style.display = "none";
    }

    handleThumbnailDisplay(thumbnails, index);

    thumbnails[index].classList.add("active");

    let tag;
    if (refParent && refParent.dataset.tag) {
      tag = refParent.dataset.tag;
      const sliderFeaturedImage = document.querySelector(
        `img.Slider-featuredImage[data-tag="${tag}"]`
      );
      sliderFeaturedImage.src = thumbnails[index].href;
    }
    scrollElementIntoView(thumbnails[index], index);
  }

  const navigationRows = document.getElementsByClassName(
    "Slider-navigation-row"
  );

  function handleLeftNavClick(e) {
    e.stopPropagation();
    let tag;
    if (e.target && e.target.dataset.tag) {
      tag = e.target.dataset.tag;
    }

    const navRow = document.querySelector(
      `div.Slider-navigation-row[data-tag="${tag}"]`
    );

    let thumbnails = navRow.getElementsByClassName("Slider-thumbnail");
    const activeIndex = getActiveThumbnailIndex(navRow);
    if (activeIndex > 0) {
      setActiveThumbnail(
        activeIndex > 0 ? activeIndex - 1 : thumbnails.length - 1,
        navRow
      );
    }
  }
  function handleRightNavClick(e) {
    e.stopPropagation();
    let tag;
    if (e.target && e.target.dataset.tag) {
      tag = e.target.dataset.tag;
    }

    const navRow = document.querySelector(
      `div.Slider-navigation-row[data-tag="${tag}"]`
    );

    let thumbnails = navRow.getElementsByClassName("Slider-thumbnail");
    const activeIndex = getActiveThumbnailIndex(navRow);
    if (activeIndex < thumbnails.length - 1) {
      setActiveThumbnail(
        activeIndex < thumbnails.length - 1 ? activeIndex + 1 : 0,
        navRow
      );
    }
  }

  for (const row of navigationRows) {
    const navLeft = row.getElementsByClassName("thumbnail-nav-left");
    const navRight = row.getElementsByClassName("thumbnail-nav-right");

    if (navLeft && navLeft[0]) {
      navLeft[0].addEventListener("click", handleLeftNavClick);
    }
    if (navRight && navRight[0]) {
      navRight[0].addEventListener("click", handleRightNavClick);
    }
  }
});
